import { staticPositionComponent } from "../../../componentLibrary/staticPositionComponent.js";
import { Entity } from "../../../entity.js";
import { FlickerLightRenderer } from "./flickerLightRenderer.js";
/**
 * A decorative flickering fluorescent light pool on the floor.
 * Add via sceneManager.addEntity() so it renders under the player.
 * @author Claude
 */
export class FlickerLightController extends Entity {
    constructor(config) {
        super();
        const pos = new staticPositionComponent(config.position);
        super.addComponent(pos);
        super.setRenderer(new FlickerLightRenderer(config));
    }
}
